import api from '@/utils/api';
import {
    createSingleFileFormData,
    mergeUploadResults,
    toFileArray
} from '@/utils/fileUploadQueue';

function data(response) {
    return response && response.data;
}

export default {
    list(params) {
        return api.get(`/api/objects/unified`, {params}).then(data);
    },
    getAccessSettings() {
        return api.get(`/api/objects/unified/access-settings`).then(data);
    },
    updateAccessSettings(accessConfig) {
        return api.put(`/api/objects/unified/access-settings`, {access_config: accessConfig}).then(data);
    },
    getObjectAccess(params = {}) {
        return api.get(`/api/objects/unified/object-access`, {params}).then(data);
    },
    updateObjectAccess(id, accessConfig) {
        return api.put(`/api/objects/unified/object-access/${id}`, {access_config: accessConfig}).then(data);
    },
    create(payload) {
        return api.post(`/api/objects/unified`, payload).then(data);
    },
    get(id) {
        return api.get(`/api/objects/unified/${id}`).then(data);
    },
    progress(id) {
        return api.get(`/api/objects/unified/${id}/progress`).then(data);
    },
    createTarget(payload) {
        return api.post(`/api/targets`, payload).then(data);
    },
    updateTarget(payload) {
        return api.put(`/api/targets`, payload).then(data);
    },
    deleteTarget({building_process_id, work_id}) {
        return api.delete(`/api/targets`, {
            params: {
                building_process_id,
                work_id
            }
        }).then(data);
    },
    setTargetStatus(id, isActive) {
        return api.patch(`/api/targets/${id}/status`, {is_active: Boolean(isActive)}).then(data);
    },
    createMaterialTarget(payload) {
        return api.post(`/api/material-targets`, payload).then(data);
    },
    updateMaterialTarget(id, payload) {
        return api.put(`/api/material-targets/${id}`, payload).then(data);
    },
    deleteMaterialTarget(id) {
        return api.delete(`/api/material-targets/${id}`).then(data);
    },
    setMaterialTargetStatus(id, isActive) {
        return api.patch(`/api/material-targets/${id}/status`, {is_active: Boolean(isActive)}).then(data);
    },
    consumption(id) {
        return api.get(`/api/objects/unified/${id}/consumption`).then(data);
    },
    downloadReport({buildingProcessId, chatId}) {
        const params = {
            building_process_id: buildingProcessId,
            download: true
        };
        if (chatId) {
            params.chat_id = chatId;
        }
        return api.get(`/api/report-xls`, {
            params,
            responseType: `blob`
        });
    },
    update(id, payload) {
        return api.put(`/api/objects/unified/${id}`, payload).then(data);
    },
    deleteObject(id) {
        return api.delete(`/api/objects/unified/${id}`).then(data);
    },
    activity(id, params = {}) {
        return api.get(`/api/objects/unified/${id}/activity`, {params}).then(data);
    },
    addComment(id, text) {
        return api.post(`/api/objects/unified/${id}/comments`, {text}).then(data);
    },
    updateComment(id, commentId, text) {
        return api.put(`/api/objects/unified/${id}/comments/${commentId}`, {text}).then(data);
    },
    deleteComment(id, commentId) {
        return api.delete(`/api/objects/unified/${id}/comments/${commentId}`).then(data);
    },
    async addCommentFiles(id, commentId, files, options = {}) {
        const results = [];
        for (const file of toFileArray(files)) {
            const formData = createSingleFileFormData(`files`, file);
            const result = await api.post(`/api/objects/unified/${id}/comments/${commentId}/files`, formData, {
                headers: {'Content-Type': 'multipart/form-data'},
                params: options.initial === true ? {initial: true} : undefined
            }).then(data);
            results.push(result);
        }
        return mergeUploadResults(results);
    },
    deleteCommentFile(id, commentId, fileId) {
        return api.delete(`/api/objects/unified/${id}/comments/${commentId}/files/${fileId}`).then(data);
    }
};
